import { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const MessageInput = ({ onSendMessage, disabled, replyToName }) => {
  const intl = useIntl();
  const [value, setValue] = useState('');

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed) { return; }
    onSendMessage(trimmed);
    setValue('');
  };

  return (
    <Form.PromptBox
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onSubmit={submit}
      disabled={disabled}
      placeholder={intl.formatMessage(messages.replyTo, {
        name: replyToName || '—',
      })}
      ariaLabel={intl.formatMessage(messages.replyAriaLabel)}
      size="lg"
    />
  );
};

MessageInput.propTypes = {
  onSendMessage: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  replyToName: PropTypes.string,
};

MessageInput.defaultProps = {
  disabled: false,
  replyToName: '',
};

export default MessageInput;
